import script from "./CartItemRemove.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartItemRemove.vue?vue&type=script&lang=ts&setup=true"

import "./CartItemRemove.vue?vue&type=style&index=0&id=b64b8046&lang=scss"

const __exports__ = script;

export default __exports__